const formatRequestDate = (createdAt: string) =>
    new Date(createdAt).toLocaleDateString('default', { month: 'long', day: 'numeric', year: 'numeric' })

export default formatRequestDate
